"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NolimitPromoMainView = void 0;
const NolimitPromotionPlugin_1 = require("./NolimitPromotionPlugin");
const NolimitApplication_1 = require("@nolimitcity/slot-launcher/bin/NolimitApplication");
const ImgLoader_1 = require("@nolimitcity/slot-launcher/bin/loader/ImgLoader");
const PromoPanelAssetConfig_1 = require("./config/PromoPanelAssetConfig");
const GUIScrollContainer_1 = require("@nolimitcity/slot-launcher/bin/gui/scroll/GUIScrollContainer");
const GuiLayout_1 = require("@nolimitcity/slot-launcher/bin/gui/utils/GuiLayout");
const MenuButton_1 = require("./MenuButton");
const ConfirmBetPopUpView_1 = require("./feature/generic/ConfirmBetPopUpView");
const Label_1 = require("@nolimitcity/slot-launcher/bin/gui/labels/Label");
const PromoPanelLabelIDs_1 = require("./enums/PromoPanelLabelIDs");
const PromoPanelConfig_1 = require("./config/PromoPanelConfig");
const PromoPanelTextStyles_1 = require("./config/PromoPanelTextStyles");
const CloseButton_1 = require("./CloseButton");
class NolimitPromoMainView extends PIXI.Container {
    get popUpView() {
        return this._popUpView;
    }
    set backgroundColor(value) {
        this._backgroundColor = value;
        this._background.tint = this._backgroundColor;
    }
    constructor(controller, featureMap) {
        super();
        this._backgroundColor = PIXI.utils.string2hex("#ee2552");
        this.buttons = [];
        this.controller = controller;
        this.init(featureMap);
    }
    init(featureMap) {
        this._background = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._background.name = "background";
        this.addChild(this._background);
        this._menuBGLandscape = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.NAV_BG_LANDSCAPE));
        this._menuBGLandscape.name = "_menuBGLandscape";
        this._menuBGPortrait = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.NAV_BG_PORTRAIT));
        this._menuBGPortrait.name = "_menuBGPortrait";
        this._menuTop = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.TOP_BAR));
        this._menuTop.name = "_menuTop";
        this._menuPortraitHeader = this.createPortraitHeader();
        this._menuBGDivider = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._menuBGDivider.name = "_menuBGDivider";
        this.scrollContainer = new GUIScrollContainer_1.GUIScrollContainer(100, 100, false, true, true, {
            color: 0xffffff,
            thickness: 3
        });
        this.content = new PIXI.Container();
        this.scrollContainer.addContent(this.content);
        this.addChild(this.scrollContainer);
        this.addChild(this._menuBGLandscape, this._menuBGPortrait, this._menuBGDivider, this._menuTop, this._menuPortraitHeader);
        this.buttons = this.createMenuButtons(featureMap);
        this.buttonContainer = new PIXI.Container();
        this.buttonContainer.name = "buttonContainer";
        this.buttonContainer.addChild(...this.buttons);
        this.addChild(this.buttonContainer);
        this.closeButton = new CloseButton_1.CloseButton("close", () => {
            this.onButtonClick(this.closeButton);
        });
        this.closeButton.enable(true);
        this.addChild(this.closeButton);
        this._popUpView = new ConfirmBetPopUpView_1.ConfirmBetPopUpView();
        this.addChild(this._popUpView);
    }
    createPortraitHeader() {
        const container = new PIXI.Container();
        const icon = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.NOLIMIT_PROMOTIONS_LOGO));
        const nolimit = new Label_1.Label(NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(PromoPanelLabelIDs_1.PromoPanelLabelIDs.PROMO_PANEL_HEADING + PromoPanelConfig_1.PromoPanelConfig.SINGLE_BLANK_SPACE), PromoPanelTextStyles_1.PromoPanelTextStyles.PROMO_PANEL_HEADING);
        const features = new Label_1.Label(NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(PromoPanelLabelIDs_1.PromoPanelLabelIDs.PROMO_PANEL_PROMOTIONS_HEADING), PromoPanelTextStyles_1.PromoPanelTextStyles.PROMO_PANEL_PROMOTIONS_HEADING);
        nolimit.position.set(icon.width + 10, 5);
        features.position.set(nolimit.x + nolimit.width, 5);
        container.addChild(icon, nolimit, features);
        container.pivot.set(Math.floor(container.width * 0.5), 0);
        return container;
    }
    onResize() {
        var _a;
        this.position.set(NolimitApplication_1.NolimitApplication.screenBounds.left, NolimitApplication_1.NolimitApplication.screenBounds.top);
        if (this.popUpView.isOpen) {
            this.popUpView.resize();
        }
        this._background.tint = this._backgroundColor;
        this._background.width = NolimitApplication_1.NolimitApplication.screenBounds.width;
        this._background.height = NolimitApplication_1.NolimitApplication.screenBounds.height; // - NolimitPromotionPlugin.keypadPlugin.getBalanceBarHeight();
        this._menuBGDivider.width = NolimitApplication_1.NolimitApplication.screenBounds.width;
        this._menuBGDivider.height = 2;
        this._menuBGDivider.position.set(0, NolimitApplication_1.NolimitApplication.screenBounds.height - NolimitPromotionPlugin_1.NolimitPromotionPlugin.keypadPlugin.getBalanceBarHeight() - this._menuBGDivider.height);
        const menuWidthLandscape = 150;
        const topBarHeight = 122;
        const menuHeightPortrait = 153;
        const bottomCutOff = NolimitApplication_1.NolimitApplication.screenBounds.height - NolimitPromotionPlugin_1.NolimitPromotionPlugin.keypadPlugin.getBalanceBarHeight() - this._menuBGDivider.height;
        const scrollViewPort = new PIXI.Rectangle();
        scrollViewPort.x = NolimitApplication_1.NolimitApplication.isLandscape ? menuWidthLandscape : 0;
        scrollViewPort.y = NolimitApplication_1.NolimitApplication.isLandscape ? 0 : topBarHeight;
        scrollViewPort.width = NolimitApplication_1.NolimitApplication.isLandscape ? (NolimitApplication_1.NolimitApplication.screenBounds.width - menuWidthLandscape) : NolimitApplication_1.NolimitApplication.screenBounds.width;
        scrollViewPort.height = NolimitApplication_1.NolimitApplication.isLandscape ? bottomCutOff : (bottomCutOff - menuHeightPortrait - topBarHeight);
        if (NolimitApplication_1.NolimitApplication.isLandscape) {
            this._menuBGLandscape.visible = true;
            this._menuBGPortrait.visible = false;
            this._menuTop.visible = false;
            this._menuPortraitHeader.visible = false;
            this._menuBGLandscape.height = this._menuBGDivider.y;
            this.closeButton.showHidePlate(true);
            GuiLayout_1.GuiLayout.align(this.buttons, 10, GuiLayout_1.Align.CENTER, GuiLayout_1.Direction.VERTICAL);
            this.buttonContainer.position.set(8, 32);
            this.closeButton.position.set(NolimitApplication_1.NolimitApplication.screenBounds.width - this.closeButton.width * 0.5 - 10, 78);
        }
        else {
            this._menuBGLandscape.visible = false;
            this._menuBGPortrait.visible = true;
            this._menuTop.visible = true;
            this._menuPortraitHeader.visible = true;
            this.closeButton.showHidePlate(false);
            this._menuTop.width = NolimitApplication_1.NolimitApplication.screenBounds.width;
            this._menuPortraitHeader.position.set(Math.floor(NolimitApplication_1.NolimitApplication.screenBounds.width * 0.5), 40);
            this._menuBGPortrait.width = NolimitApplication_1.NolimitApplication.screenBounds.width;
            this._menuBGPortrait.position.set(0, this._menuBGDivider.y - this._menuBGPortrait.height);
            GuiLayout_1.GuiLayout.align(this.buttons, 10, GuiLayout_1.Align.CENTER, GuiLayout_1.Direction.HORIZONTAL);
            this.buttonContainer.position.set(10, this._menuBGDivider.y - 153 + 10);
            this.closeButton.position.set(NolimitApplication_1.NolimitApplication.screenBounds.width - this.closeButton.width * 0.5 - 10, 63);
        }
        this.scrollContainer.position.set(scrollViewPort.x, scrollViewPort.y);
        this.scrollContainer.resize(scrollViewPort.width, scrollViewPort.height);
        this.scrollContainer.setScrollDelta(this.scrollContainer);
        (_a = this.currentContent) === null || _a === void 0 ? void 0 : _a.onResize();
    }
    createMenuButtons(featureMap) {
        const buttons = [];
        const featureControllers = [...featureMap.values()];
        featureControllers.sort((a, b) => {
            return a.config.displayOrder - b.config.displayOrder;
        });
        for (let controller of featureControllers) {
            buttons.push(this.createButton(controller.id, controller.config));
        }
        return buttons;
    }
    onButtonClick(button) {
        if (button.name == "close") {
            this.controller.close();
            return;
        }
        this.controller.openFeature(button.name);
    }
    updateButtonState(currentFeature) {
        for (let btn of this.buttons) {
            if (btn.name == currentFeature) {
                btn.toggled = true;
            }
            else {
                btn.toggled = false;
            }
        }
    }
    createButton(id, config) {
        const button = new MenuButton_1.MenuButton(id, config);
        button.addClickCallback(() => {
            this.onButtonClick(button);
        });
        return button;
    }
    enableInteraction(enable, filter) {
        if (filter != undefined) {
            for (let button of this.buttons) {
                if (filter.indexOf(button.name) > -1) {
                    button.enable(enable);
                }
            }
        }
        else {
            for (let button of this.buttons) {
                button.enable(enable);
            }
        }
    }
    open() {
        this.onResize();
    }
    switchContent(view) {
        this.currentContent = view;
        this.content.removeChildren();
        this.content.addChild(this.currentContent);
        this.currentContent.onResize();
        this.scrollContainer.updateContent();
        this.scrollContainer.setScrollDelta(this.scrollContainer);
    }
    clearContent() {
        this.content.removeChildren();
        this.scrollContainer.updateContent();
    }
    contentUpdated() {
        this.scrollContainer.updateContent();
    }
}
exports.NolimitPromoMainView = NolimitPromoMainView;
//# sourceMappingURL=NolimitPromoMainView.js.map